/**
 * @fileoverview Collapsible "how to export from Ads Manager" steps for the Meta CSV import.
 * @module features/ad-spends/components/import/ExportInstructions
 */

import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export function ExportInstructions(): ReactElement {
  const { t } = useTranslation('features-ad-spends')
  return (
    <details className="rounded-md bg-muted/50 p-3 text-xs text-muted-foreground">
      <summary className="cursor-pointer text-sm font-medium text-foreground">
        {t('import.howTo.title', { defaultValue: 'How to export from Ads Manager' })}
      </summary>
      <ol className="mt-2 list-decimal space-y-1 pl-5">
        <li>{t('import.howTo.language', { defaultValue: 'Column names must be in English: switch Facebook to English before exporting.' })}</li>
        <li>{t('import.howTo.level', { defaultValue: 'Open Ads Manager → Ad sets and pick the date range.' })}</li>
        <li>{t('import.howTo.columns', { defaultValue: 'Columns → Customize columns: add "Ad set ID" and "Amount spent". Breakdown → By time: Day.' })}</li>
        <li>{t('import.howTo.product', { defaultValue: 'Report 1: add the breakdown "Product ID". Export as CSV.' })}</li>
        <li>{t('import.howTo.country', { defaultValue: 'Report 2: the same, with the breakdown "Country" instead. Export as CSV.' })}</li>
        <li>{t('import.howTo.save', { defaultValue: "Save both as saved reports, so next time it's two clicks." })}</li>
      </ol>
    </details>
  )
}
